/** Keep in sync with `@media` blocks in `src/index.css`. */
export const MOBILE_BREAKPOINT = 1024;

/**
 * Phone + iPhone landscape + coarse touch tablets.
 * Narrow desktop windows also match via max-width.
 */
export const MOBILE_MEDIA_QUERY =
  `(max-width: ${MOBILE_BREAKPOINT - 1}px), ((pointer: coarse) and (hover: none) and (max-width: 1366px))`;

export function isMobileViewport(input: {
  width: number;
  pointerCoarse?: boolean;
  hoverNone?: boolean;
}): boolean {
  if (input.width <= MOBILE_BREAKPOINT - 1) return true;
  return Boolean(input.pointerCoarse && input.hoverNone && input.width <= 1366);
}

/** HTTPS on 443 leaves `location.port` empty; never report "80". */
export function displayHostPort(locationLike: { protocol: string; port: string }): string {
  if (locationLike.port) return locationLike.port;
  return locationLike.protocol === 'https:' ? '443' : '80';
}
